import { EstimateWithAccountInfo } from '@lune-fe/dapi-models'
import { formatNumbers, IconButtonDropdownNew } from '@lune-fe/lune-ui-lib'
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import CreateIcon from '@mui/icons-material/Create'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { EstimateTypeSlug } from 'views/CalculateEmissions/EmissionCalculationDefinitions'

const LogisticsEmissionCalculationContextMenu: FC<{
    calculation: EstimateWithAccountInfo
    editable?: boolean
}> = ({ calculation, editable }) => {
    const navigate = useNavigate()
    const [open, setOpen] = useState<boolean>(false)

    return (
        <IconButtonDropdownNew
            sx={{ ...(open && { opacity: '1 !important' }) }}
            onToggle={(isOpen) => setOpen(isOpen)}
            menuAutoWidth
            icon={<MoreVertOutlinedIcon />}
        >
            {editable && (
                <IconButtonDropdownNew.MenuItem
                    icon={<CreateIcon />}
                    title={`Edit`}
                    onClick={() =>
                        navigate(
                            `/calculate-emissions/${EstimateTypeSlug(calculation.estimateType)}/${
                                calculation.id
                            }`,
                        )
                    }
                />
            )}
            <IconButtonDropdownNew.MenuItem
                icon={<CloudDownloadOutlinedIcon />}
                title={`Offset`}
                onClick={() => navigate(`/order?amount=${formatNumbers(calculation.quantity, 2)}`)}
            />
        </IconButtonDropdownNew>
    )
}

export default LogisticsEmissionCalculationContextMenu
